/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import DateField from "../../../components/form/DateField";
import TextField from "../../../components/form/TextField";
import {
  useAddVideoMutation,
  useEditVideoMutation,
} from "../../../features/videos/videosAPI";
import ErrorMessage from "../../ui/ErrorMessage";

function VideoForm({ initialData = {} }) {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    ...initialData,
  });
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [
    addVideo,
    { isSuccess: isAddSuccess, isError: isAddError, isLoading: isAddLoading },
  ] = useAddVideoMutation();

  const [
    editVideo,
    {
      isSuccess: isEditSuccess,
      isError: isEditError,
      isLoading: isEditLoading,
    },
  ] = useEditVideoMutation();

  function handleChange(event) {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (initialData?.id) {
      delete formValues?.uploadDate;
      editVideo({ id: initialData?.id, data: formValues });
    } else {
      const creationDate = new Date()?.toISOString();
      addVideo({ ...formValues, createdAt: creationDate });
    }
  }

  useEffect(() => {
    if (initialData?.id) {
      let date = initialData?.createdAt;
      let dateString = "";
      if (date) {
        date = new Date(date);
        const year = date.getFullYear();
        const month =
          date.getMonth() < 9
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        dateString = `${year}-${month}-${day}`;
        setFormValues({ ...formValues, uploadDate: dateString });
      }
    }
  }, [initialData, setFormValues]);

  useEffect(() => {
    if (isAddSuccess || isEditSuccess) {
      navigate("/admin/videos");
    } else if (isAddError || isEditError) {
      setShowErrorMessage(true);
    }
  }, [isAddSuccess, isAddError, isEditError, isEditSuccess, navigate]);

  return (
    <div className="max-w-3xl mx-auto">
      <form className="space-y-6" onSubmit={handleSubmit}>
        <TextField
          id="title"
          label="Title"
          type="text"
          onChange={handleChange}
          value={formValues?.title}
          required
        />
        <TextField
          id="description"
          label="Description"
          onChange={handleChange}
          value={formValues?.description}
          type="text"
          required
        />
        <TextField
          id="url"
          label="Video URL"
          onChange={handleChange}
          value={formValues?.url}
          type="url"
          required
        />
        <TextField
          id="views"
          label="Views"
          onChange={handleChange}
          value={formValues?.views}
          type="text"
          required
        />
        <TextField
          id="duration"
          label="Duration"
          type="text"
          onChange={handleChange}
          value={formValues?.duration}
          required
        />
        {initialData?.id && (
          <DateField
            id="createdAt"
            label="Upload Date"
            onChange={handleChange}
            value={formValues?.uploadDate}
            required
            disabled={true}
          />
        )}
        {showErrorMessage && <ErrorMessage />}
        <div
          style={{
            display: "grid",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            type="submit"
            className="btn btn-primary text-slate-600"
            style={{
              padding: "0.5rem 2rem",
              marginTop: "0.5rem",
              width: "fit-content",
            }}
            disabled={isAddLoading || isEditLoading}
          >
            {initialData?.id ? "Update" : "Add"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default VideoForm;
